import { Box, Button, Stack } from "@mui/material";
import { useState } from "react";
import api, { UserProfileDto, UserUpdateDto, UserUpdateDtoRole, VendorDto } from "../../../api";
import { TabPanel } from "../../controls";
import { useUserContext } from "../../UserContext";
import { DefaultMessageDialogOptions, MessageDialog, MessageDialogButton, MessageDialogButtons, MessageDialogIcon, MessageDialogOptions, notif } from "../../utils";
import { UserDialog } from "./UserDialog";
import { UsersGrid } from "./UsersGrid";

type MessageOrigin = "delete";

export const UsersPage = () => {
  const { user } = useUserContext();
  const [selected, setSelected] = useState<UserProfileDto | null>(null);
  const [edit, setEdit] = useState<Partial<UserUpdateDto> | null>(null);
  const [message, setMessage] = useState<MessageDialogOptions<MessageOrigin>>(DefaultMessageDialogOptions<MessageOrigin>());

  const onRowSelected = (row: VendorDto | null) => {
    setSelected(row);
  };
  const onInsert = () => {
    setEdit({ email: "", role: UserUpdateDtoRole.User, isEnabled: true });
  };
  const onEdit = () => {
    if (selected !== null) {
      setEdit({
        id: selected.id,
        email: selected.email,
        role: selected.role as any,
        isEnabled: selected.isEnabled,
      });
    }
  };
  const onDelete = () => {
    if (selected?.id) {
      if (selected.id === user.id) {
        notif("Cannot delete self", "error");
      } else {
        setMessage({
          open: true,
          title: "DELETE USER",
          buttons: MessageDialogButtons.YesNo,
          icon: MessageDialogIcon.Question,
          content: `Do you want to delete user '${selected.email}'?`,
          origin: "delete",
        });
      }
    }
  };
  const deleteUser = async () => {
    if (selected?.id) {
      try {
        await api.user.delete(selected.id);
      } catch (err) {
        notif(err, "error");
      }
    }
  };

  const onMessageSubmit = async (button: MessageDialogButton, origin?: MessageOrigin) => {
    setMessage({ open: false });
    if (origin === "delete" && button === MessageDialogButton.Yes) {
      await deleteUser();
    }
  };
  const onUserDialogSubmit = (dto: VendorDto | null) => {
    setEdit(null);
    if (dto !== null) setSelected(dto);
  };

  const tabUsers = () => (
    <Box maxWidth="900px">
      <UsersGrid onRowSelected={onRowSelected} />
      <Box sx={{ p: 1 }} />
      <Stack spacing={2} direction="row">
        <Button variant="contained" onClick={onInsert}>
          Add
        </Button>
        <Button variant="contained" disabled={!selected?.id} onClick={onEdit}>
          Edit
        </Button>
        <Button variant="contained" disabled={!selected?.id} onClick={onDelete}>
          Delete
        </Button>
      </Stack>
      <UserDialog user={edit} onSubmit={onUserDialogSubmit} />
      <MessageDialog options={message} onSubmit={onMessageSubmit} />
    </Box>
  );

  return (
    <Box>
      <TabPanel name="users" items={[{ label: "USERS", children: tabUsers() }]} />
    </Box>
  );
};
